<div class="col-12 d-flex justify-content-center">
  <mat-spinner *ngIf="loading"></mat-spinner>
</div>


<div *ngIf="!loading">
  <div class="js-banner">
    <div *ngFor="let banner of bannerData">
      <div *ngIf="!isMobile">
        <div class="banner-static" *ngIf="banner.linkSetting === 0 || banner.linkSetting === -1"
          style="display: block; background-image: url(/api/images/{{banner.desktopImage}});">
        </div>
        <a class="banner-static" [href]="banner.link" *ngIf="banner.linkSetting === 1"
          style="display: block; background-image: url(/api/images/{{banner.desktopImage}});">
        </a>
        <div class="banner-static" [routerLink]="['/productCategory', banner.tagId, 0]" *ngIf="banner.linkSetting === 2"
          style="display: block; background-image: url(/api/images/{{banner.desktopImage}});">
        </div>
      </div>
      <div *ngIf="isMobile">
        <div class="banner-static" *ngIf="banner.linkSetting === 0"
          style="display: block; background-image: url(/api/images/{{banner.mobileImage}});">
        </div>
        <a class="banner-static" [href]="banner.link" *ngIf="banner.linkSetting === 1"
          style="display: block; background-image: url(/api/images/{{banner.mobileImage}});">
        </a>
        <div class="banner-static" [routerLink]="['/productCategory', banner.tagId, 0]" *ngIf="banner.linkSetting === 2"
          style="display: block; background-image: url(/api/images/{{banner.mobileImage}});">
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid content-wrapper">
    <div class="row mt-5" *ngIf="announcements.length > 0">
      <div class="col-12">
        <div class="index-news">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="18">
              <!-- Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) -->
              <path
                d="M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z" />
            </svg>
          </span>

          <ng-template #marqueeContent>
            <span *ngFor="let ticker of dynamicTape">
              {{ticker | googleTranslate | async}}
            </span>
          </ng-template>
          <div class="marquee" style="width: 100%;">
            <ngx-marquee pauseOnHover="true" [duration]="duration" [(pendingUpdates)]="areThereUpdates"
              [taskOnUpdateContent]="updateContent" [taskOnUpdateDuration]="updateDuration">
              <ng-container *ngTemplateOutlet="marqueeContent"></ng-container>
            </ngx-marquee>
          </div>
          <span>
            <a href="#notice-modal" class="notice-modal">MORE</a>
          </span>
        </div>
      </div>
    </div>

    <!-- 探索世界 -->
    <section class="section-wrapper" *ngIf="exploreData">
      <div class="section-title" [routerLink]="['/productCategory']">
        <img src="assets/images/index-section-icon_01.png">
        <div>{{exploreWorldTitle | googleTranslate | async}}</div>
      </div>
      <div>
        <div class="js-slider-explore mx-n3">
          <div class="index-explore" *ngFor="let explore of exploreData">
            <div *ngIf="explore.translatedButtonText" attr.data-title="{{explore.translatedButtonText}}">
              <div class="" [routerLink]="['/productCategory', 0, explore.regionID]" *ngIf="explore.linkType == 1">
                <div class="col-md-9 p-0">
                  <img [src]="'/api/images/' + explore.image" class="img-fluid">
                </div>
                <div class="col-md-4 index-explore-des">
                  <div class="title">{{explore.title | googleTranslate | async}}</div>
                  <div class="text">
                    <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(explore.description | googleTranslate | async)">
                    </p>
                    <div class="d-flex justify-content-end">
                      <a [routerLink]="['/productCategory', 0, explore.regionID]" class="btn-explore">
                        <img src="assets/images/btn-explore.png" alt="" class="img-fluid">
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="" [routerLink]="['/productCategory', explore.tagID, 0]" *ngIf="explore.linkType == 2">
                <div class="col-md-9 p-0">
                  <img [src]="'/api/images/' + explore.image" class="img-fluid">
                </div>
                <div class="col-md-4 index-explore-des">
                  <div class="title">{{explore.title | googleTranslate | async}}</div>
                  <div class="text">
                    <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(explore.description | googleTranslate | async)">
                    </p>
                    <div class="d-flex justify-content-end">
                      <a [routerLink]="['/productCategory', explore.tagID, 0]" class="btn-explore">
                        <img src="assets/images/btn-explore.png" alt="" class="img-fluid">
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <a class="" [href]="explore.linkUrl" *ngIf="explore.linkType == 3">
                <div class="col-md-9 p-0">
                  <img [src]="'/api/images/' + explore.image" class="img-fluid">
                </div>
                <div class="col-md-4 index-explore-des">
                  <div class="title">{{explore.title | googleTranslate | async}}</div>
                  <div class="text">
                    <p [innerHTML]="sanitizer.bypassSecurityTrustHtml(explore.description | googleTranslate | async)">
                    </p>
                    <div class="d-flex justify-content-end">
                      <a [href]="explore.linkUrl" class="btn-explore">
                        <img src="assets/images/btn-explore.png" alt="" class="img-fluid">
                      </a>
                    </div>
                  </div>
                </div>
              </a>
            </div>


          </div>
        </div>
      </div>
    </section>
    <div class="divider-3"></div>


    <!-- 今日必搶 -->
    <section class="section-wrapper" [hidden]="!grabData" id="grabToday" *ngIf="grabData">
      <div class="section-title">
        <img src="assets/images/index-section-icon_01.png">
        <div>{{"今日必搶" | translate}}</div>
      </div>
      <div class="row d-block d-xl-none mx-n3">
        <div class="col-xl-3 col-sm-12 mb-3">
          <div class="index-deal">
            <div class="bg-top"></div>

            <div class="deal-test">
              <img src="assets/images/deal-title-1.png" alt="限時下殺" class="title-1">

              <div class="deal-xs-wrapper">
                <div class="title">
                  <img src="assets/images/deal-title-2.png" alt="搶購倒數" class="title-2">
                </div>
                <ngx-countdown [time]="grabData.leftTime" [render]="render" format="HH:mm:ss" [millisecond]="true">
                  <ng-template #render let-data>
                    <div class="countdown">
                      <div><span>{{ data.fragments[0] }}</span> <small>{{"時" | translate}}</small></div>
                      <div><span>{{ data.fragments[1] }}</span> <small>{{"分" | translate}}</small></div>
                      <div><span>{{ data.fragments[2] }}</span> <small>{{"秒" | translate}}</small></div>
                    </div>
                  </ng-template>
                </ngx-countdown>
              </div>
            </div>

            <div class="bg-btm"></div>
          </div>
        </div>
      </div>
      <div class="row no-gutters section-deal">
        <div class="col-xl-3 col-sm-12 mb-3 d-none d-xl-block">
          <div class="index-deal">
            <div class="bg-top"></div>

            <div class="deal-test">
              <img src="assets/images/deal-title-1.png" alt="限時下殺" class="title-1">

              <div class="deal-xs-wrapper">
                <div class="title">
                  <img src="assets/images/deal-title-2.png" alt="搶購倒數" class="title-2">
                </div>
                <ngx-countdown [time]="grabData.leftTime" [render]="render" format="HH:mm:ss" [millisecond]="true">
                  <ng-template #render let-data>
                    <div class="countdown">
                      <div><span>{{ data.fragments[0] }}</span> <small>{{"時" | translate}}</small></div>
                      <div><span>{{ data.fragments[1] }}</span> <small>{{"分" | translate}}</small></div>
                      <div><span>{{ data.fragments[2] }}</span> <small>{{"秒" | translate}}</small></div>
                    </div>
                  </ng-template>
                </ngx-countdown>
              </div>
            </div>

            <div class="bg-btm"></div>
          </div>
        </div>

        <div class="col-xl-9 pl-0 pl-lg-2">
          <div class="js-slider-deal">
            <div class="col-12 p-0 mb-3" *ngFor="let item of grabData.GrabTodayPlan">
              <div class="product-card deal">
                <div class="product-card-image"
                  style="display: block; background-image: url(/api/images/{{item.product.coverImg}});">
                </div>
                <div class="product-card-body">
                  <div class="product-title ">
                    <a [routerLink]="['/product', item.product.ID]">{{item.product.title | googleTranslate | async}}</a>
                  </div>
                  <div class="product-des truncate-2">{{item.product.summary | googleTranslate | async}}</div>
                  <div class="product-btm d-flex justify-content-between mt-2">
                    <div class="product-ribbon">{{"限時特賣" | translate}}</div>
                    <div class="product-price">
                      <!-- <small>{{"每人" | translate}}</small> -->
                      <span
                        [innerHTML]="item.product.lowestPrice - item.product.deduct | currencyExchange:false:true | async"></span>
                      <small>{{"起" | translate}}</small>
                      <small class="product-price-original">
                        <span [innerHTML]="item.product.lowestPrice | currencyExchange:false:true | async"></span>
                        <span>{{"起" | translate}}</span>
                      </small>
                    </div>
                  </div>

                </div>
                <a [routerLink]="['/product', item.product.ID]" class="link-spanner"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="divider-3"></div>


    <!-- 體驗潛水 -->
    <div *ngFor="let category of categoryData">
      <section class="section-wrapper">
        <div class="section-title">
          <img [src]="'/api/images/' + category.image">
          <div>{{category.text | googleTranslate | async}}</div>
        </div>
        <div class="row mx-n3 no-gutters"
          [ngClass]="{'scroll-x-container': innerWidth < 500, 'scroll-product': innerWidth < 500}">
          <div class="col-xl-3 col-lg-6 col-sm-6 col-10 mb-3" *ngFor="let product of category.Product">
            <div class="product-card">
              <div class="product-sale" *ngIf="product.isSale"></div>
              <div class="product-card-image"
                style="display: block; background-image: url(/api/images/{{product.coverImg}});">
                <a [routerLink]="['/product', product.ID]" class="link-spanner"></a>
              </div>
              <div class="product-card-body">
                <div class="product-title text-truncate">
                  <a [routerLink]="['/product', product.ID]">{{product.title | googleTranslate | async}}</a>
                </div>
                <div class="product-des">{{product.Country.name | googleTranslate | async}} {{product.Region.name |
                  googleTranslate | async}}</div>
                <div class="d-flex justify-content-between" [ngClass]="{ 'flex-column': product.isSale }">
                  <div class="product-des">{{"觀看次數" | translate}}：{{product.viewCount}}{{"次" | translate}}
                  </div>
                  <div class="product-price" *ngIf="!product.isSale">
                    <span [innerHTML]="product.lowestPrice | currencyExchange:true:false | async"></span>
                    <small>{{"起" | translate}}</small>
                  </div>
                  <div class="product-price text-sale align-self-end" *ngIf="product.isSale">
                    <small class="text-gray-m ml-auto pr-2 align-self-center">
                      <s>
                        <span [innerHTML]="product.lowestPrice | currencyExchange:true:false | async"></span>
                        <small>{{"起" | translate}}</small>
                      </s>
                    </small>
                    <span
                      [innerHTML]="product.lowestPrice - product.deduct | currencyExchange:true:false | async"></span>
                    <small>{{"起" | translate}}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 col-md-4 col-lg-3 mx-auto">
            <a [routerLink]="['/categoryDetail', category.ID]"
              class="btn btn-outline-primary btn-lg btn-block rounded-0">{{"看更多" | translate}}</a>
          </div>
        </div>
      </section>
      <div class="divider-3"></div>
    </div>


    <!-- 熱門行程 -->
    <section class="section-wrapper">
      <div class="section-title">
        <img src="assets/images/index-section-icon_01.png" alt="">
        <div>{{"熱門行程" | translate}}</div>
      </div>
      <div class="row mx-n3 no-gutters"
        [ngClass]="{'scroll-x-container': innerWidth < 500, 'scroll-product': innerWidth < 500}">
        <div class="col-xl-4 col-lg-6 col-sm-6 col-10 mb-3" *ngFor="let item of popularData; let i = index">
          <div class="product-card">
            <div class="product-sale" *ngIf="item.isSale"></div>
            <div class="product-card-image"
              style="display: block; background-image: url(/api/images/{{item.Product.coverImg}});">
              <a [routerLink]="['/product', item.Product.ID]" class="link-spanner">
              </a>
            </div>
            <div class="product-card-body">
              <div class="product-title text-truncate">
                <a [routerLink]="['/product', item.Product.ID]">{{item.Product.title | googleTranslate | async}}</a>
              </div>
              <div class="product-des">{{item.Product.Country.name | googleTranslate | async}}
                {{item.Product.Region.name | googleTranslate | async}}</div>
              <div class="d-flex justify-content-between" [ngClass]="{ 'flex-column': item.isSale }">
                <div class="product-des">{{"觀看次數" | translate}}：{{item.Product.viewCount}}{{"次" |
                  translate}}</div>
                <div class="product-price" *ngIf="!item.isSale">
                  <span [innerHTML]="item.Product.lowestPrice | currencyExchange:true:false | async"></span>
                  <small>{{"起" | translate}}</small>
                </div>
                <div class="product-price text-sale align-self-end" *ngIf="item.isSale">
                  <small class="text-gray-m ml-auto pr-2 align-self-center">
                    <s>
                      <span [innerHTML]="item.Product.lowestPrice | currencyExchange:true:false | async"></span>
                      <small>{{"起" | translate}}</small>
                    </s>
                  </small>
                  <span
                    [innerHTML]="item.Product.lowestPrice - item.deduct | currencyExchange:true:false | async"></span>
                  <small>{{"起" | translate}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-4 col-lg-3 mx-auto">
          <a [routerLink]="['/hot']" class="btn btn-outline-primary btn-lg btn-block rounded-0">{{"看更多" |
            translate}}</a>
        </div>
      </div>
    </section>
    <div class="divider-3"></div>


    <!-- 精選主題 -->
    <section class="section-wrapper" *ngIf="featuredData">
      <div class="section-title">
        <img src="assets/images/index-section-icon_03.png">
        <div>{{"精選主題" | translate}}</div>
      </div>
      <div class="row no-gutters"
        [ngClass]="{'scroll-x-container': innerWidth < 500, 'scroll-product': innerWidth < 500}">
        <div class="col-xl-3 col-lg-6 col-sm-6 col-10 mb-3" *ngFor="let item of featuredData let i = index;">
          <div class="product-card theme" *ngIf="i < 8">
            <div class="product-card-image" style="display: block; background-image: url(/api/images/{{item.cover}});">
              <a [routerLink]="['/featuredDetail', item.ID]" class="link-spanner"></a>
            </div>
            <div class="product-card-body">
              <div class="product-title text-truncate">
                <a [routerLink]="['/featuredDetail', item.ID]" class="link-spanner">
                  <div>{{item.title | googleTranslate | async}}</div>
                  <small>{{item.productCount}}{{"個行程" | translate}}</small>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12 col-md-4 col-lg-3 mx-auto">
          <a [routerLink]="['/featured']" class="btn btn-outline-primary btn-lg btn-block rounded-0">
            {{"看更多" | translate}}
          </a>
        </div>
      </div>
    </section>
    <div class="divider-3"></div>

    <!-- 影音介紹 -->
    <section class="section-wrapper" *ngIf="videoData">
      <div class="section-title">
        <img src="assets/images/index-section-icon_07.png">
        <div>{{"影音介紹" | translate}}</div>
      </div>
      <div class="row mx-n3 no-gutters"
        [ngClass]="{'scroll-x-container': innerWidth < 500, 'scroll-product': innerWidth < 500}">
        <div class="col-xl-3 col-lg-6 col-sm-6 col-10 mb-3" *ngFor="let video of videoData; let i = index;"
          (click)="setSelectedVideo(video)">
          <div class="product-card">
            <div class="product-card-image" style="display: block; background-image: url(/api/images/{{video.image}});">
              <div class="product-card-video-icon">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
                </svg>
              </div>
            </div>
            <div class="product-card-body">
              <div class="product-title text-truncate">
                <a>{{video.title | googleTranslate | async}}</a>
              </div>
              <div class="product-des">{{video.Country.name | googleTranslate | async}} {{video.Region.name |
                googleTranslate | async}}</div>
              <div class="d-flex justify-content-between" [ngClass]="{ 'flex-column': video.isSale }">
                <div class="product-des">{{"觀看次數" | translate}}：{{video.viewCount}}{{"次" | translate}}
                </div>
                <div class="product-price" *ngIf="!video.isSale">
                  <span [innerHTML]="video.Product.lowestPrice | currencyExchange:true:false | async"></span>
                  <small>{{"起" | translate}}</small>
                </div>
                <div class="product-price text-sale align-self-end" *ngIf="video.isSale">
                  <small class="text-gray-m ml-auto pr-2 align-self-center">
                    <s>
                      <span [innerHTML]="video.Product.lowestPrice | currencyExchange:true:false | async"></span>
                      <small>{{"起" | translate}}</small>
                    </s>
                  </small>
                  <span
                    [innerHTML]="video.Product.lowestPrice - video.deduct | currencyExchange:true:false | async"></span>
                  <small>{{"起" | translate}}</small>
                </div>
              </div>
            </div>
            <a href="#video-modal" class="link-spanner popup-modal" (click)="setSelectedVideo(video)"></a>
          </div>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-md-4 col-lg-3 mx-auto">
          <a [routerLink]="['/video']" class="btn btn-outline-primary btn-lg btn-block rounded-0">{{"看更多" |
            translate}}</a>
        </div>
      </div>
    </section>
    <div class="divider-3"></div>

    <!-- 最近看過 -->
    <section class="border-0 px-2" *ngIf="recentViewedData.length > 0">
      <div class="section-title text-center">
        <img src="assets/images/index-section-icon_08.png">
        <div>{{"最近看過" | translate}}</div>
      </div>
      <div class="row mx-n3 no-gutters"
        [ngClass]="{'scroll-x-container': innerWidth < 500, 'scroll-product': innerWidth < 500}">
        <div class="col-xl-3 col-lg-6 col-sm-6 col-10 mb-3" *ngFor="let product of recentViewedData">
          <div class="product-card">
            <div class="product-sale" *ngIf="product.isSale"></div>
            <div class="product-card-image"
              style="display: block; background-image: url(/api/images/{{product.coverImg}});">
              <a [routerLink]="['/product', product.ID]" class="link-spanner"></a>
            </div>
            <div class="product-card-body">
              <div class="product-title text-truncate">
                <a [routerLink]="['/product', product.ID]">{{product.title | googleTranslate | async}}</a>
              </div>
              <div class="product-des">{{product.Country.name | googleTranslate | async}} {{product.Region.name |
                googleTranslate | async}}</div>
              <div class="d-flex justify-content-between" [ngClass]="{ 'flex-column': product.isSale }">
                <div class="product-des">{{"觀看次數" | translate}}：{{product.viewCount}}{{"次" | translate}}
                </div>
                <div class="product-price" *ngIf="!product.isSale">
                  <span [innerHTML]="product.lowestPrice | currencyExchange:true:false | async"></span>
                  <small>{{"起" | translate}}</small>
                </div>
                <div class="product-price text-sale align-self-end" *ngIf="product.isSale">
                  <small class="text-gray-m ml-auto pr-2 align-self-center">
                    <s>
                      <span [innerHTML]="product.lowestPrice | currencyExchange:true:false | async"></span>
                      <small>{{"起" | translate}}</small>
                    </s>
                  </small>
                  <span [innerHTML]="product.lowestPrice - product.deduct | currencyExchange:true:false | async"></span>
                  <small>{{"起" | translate}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

  </div>

  <div id="video-modal" class="mfp-hide white-popup-block">
    <a class="popup-modal-dismiss" href="#">
      <span aria-hidden="true">&times;</span>
    </a>
    <div class=" embed-responsive embed-responsive-16by9" *ngIf="selectedVideo">
      <iframe [src]="selectedVideo.youtube | safeUrl" class="embed-responsive-item" frameborder="0"
        allowfullscreen></iframe>
    </div>

    <a [routerLink]="['/product', selectedVideo.Product.ID]" class="card mt-4 shadow-sm" *ngIf="selectedVideo">
      <div class="row no-gutters">
        <div class="col-4 p-2">
          <img [src]="'/api/images/' + selectedVideo.image" class="card-img rounded-0">
        </div>
        <div class="col-8">
          <div class="card-body">
            <div class="product-card-body">
              <div
                class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
                (click)="closeModal()">
                <div>
                  <div class="product-title text-truncate"><a>{{selectedVideo.title | googleTranslate | async}}</a>
                  </div>
                  <div class="product-des">{{selectedVideo.Country.name | googleTranslate | async}}
                    {{selectedVideo.Region.name | googleTranslate | async}}</div>
                </div>
                <div class="text-primary d-flex">{{"看詳細介紹" | translate}} ></div>
              </div>
              <!-- <a [routerLink]="['/product', selectedVideo.Product.ID]" class="link-spanner"></a> -->
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>

  <!-- notice modal -->
  <div id="notice-modal" class="mfp-hide white-popup-block" *ngIf="announcements.length > 0">
    <a class="popup-modal-dismiss" href="#">
      <span aria-hidden="true">&times;</span>
    </a>
    <ul>
      <li *ngFor="let announcement of announcements" class="my-3">{{announcement.message | googleTranslate | async}}
      </li>
    </ul>
  </div>
</div>
